export const QUERY_KEYS = {
  tradingPhotoCardsAll: (category: 'sale' | 'exchange') => ['tradingPhotoCardsAll', category]
};
